import React from 'react';
import Waiting from '../../../components/content/Waiting';
import BlockingModal from '../../../components/framework/BlockingModal';

export type LoadingViewProps = {
  isOpen: boolean;
  message?: string | React.ReactNode;
};

const LoadingView: React.FC<LoadingViewProps> = ({
  isOpen,
  message,
}: LoadingViewProps) => {
  return (
    <BlockingModal isOpen={isOpen}>
      <Waiting title={message} />
    </BlockingModal>
  );
};

export default LoadingView;
